<div class="form-wrapper">
  @if (signInType() == 'email') {
    <form [formGroup]="emailForm">
      <mat-form-field hideRequiredMarker="true">
        <mat-label>E-mailadres</mat-label>
        <input matInput autocomplete="email" type="email" formControlName="email" />
        @if (emailForm.controls.email.hasError('required')) {
          <mat-error>E-mailadres is verplicht.</mat-error>
        }
        @if (emailForm.controls.email.hasError('emailValidator')) {
          <mat-error>Vul een geldig e-mailadres in.</mat-error>
        }
        @if (emailForm.controls.email.hasError('user-not-found')) {
          <mat-error>De combinatie van e-mail en wachtwoord is incorrect.</mat-error>
        }
        @if (emailForm.controls.email.hasError('no-rights')) {
          <mat-error>Uw account heeft geen rechten in deze omgeving.</mat-error>
        }
      </mat-form-field>
      <mat-form-field hideRequiredMarker="true">
        <mat-label>Wachtwoord</mat-label>
        <input
          matInput
          autocomplete="current-password"
          type="{{ showPasswords() ? '' : 'password' }}"
          formControlName="password"
        />
        <button
          type="button"
          matSuffix
          mat-icon-button
          [attr.aria-label]="showPasswords() ? 'Wachtwoord verbergen' : 'Wachtwoord laten zien'"
          matTooltip="{{ showPasswords() ? 'Wachtwoord verbergen' : 'Wachtwoord laten zien' }}"
          (click)="showPasswords.set(!showPasswords())"
        >
          <mat-icon>{{ showPasswords() ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        @if (emailForm.controls.password.hasError('required')) {
          <mat-error>Wachtwoord is verplicht.</mat-error>
        }
        @if (emailForm.controls.password.hasError('minlength')) {
          <mat-error>
            Het wachtwoord moet minimaal
            {{ emailForm.controls.password.errors?.minlength.requiredLength }} karakters bevatten.
          </mat-error>
        }
        @if (emailForm.controls.password.hasError('wrong-password')) {
          <mat-error>De combinatie van e-mail en wachtwoord is incorrect.</mat-error>
        }
      </mat-form-field>
      <div>
        <a class="link" routerLink="/auth/reset-password">Wachtwoord vergeten?</a>
      </div>
      <div class="action-button-wrapper">
        <button type="button" mat-stroked-button routerLink="/auth"><mat-icon>arrow_back</mat-icon> Terug</button>
        <button
          mat-flat-button
          (click)="signIn('email')"
          [disabled]="awaitingResponse()"
          [class.spinner]="awaitingResponse()"
        >
          Inloggen
        </button>
      </div>
    </form>
  }

  <!-- phone form -->
  @if (signInType() == 'phone' && signInStatus() !== 'verification') {
    <form [formGroup]="phoneForm">
      <div
        class="tel-input-wrapper"
        [ngClass]="
          (phoneForm.controls.phoneNumber.hasError('validatePhoneNumber') && phoneForm.controls.phoneNumber.touched) ||
          phoneForm.controls.phoneNumber.hasError('user-not-found') ||
          (phoneSubmitted() && !phoneForm.controls.phoneNumber.value)
            ? 'tel-input-error'
            : ''
        "
      >
        <ngx-intl-tel-input
          [cssClass]="'tel-input-input'"
          [preferredCountries]="[CountryISO.Netherlands]"
          [enableAutoCountrySelect]="false"
          [enablePlaceholder]="true"
          customPlaceholder="Mobiel nummer"
          [searchCountryFlag]="false"
          [selectFirstCountry]="false"
          [selectedCountryISO]="CountryISO.Netherlands"
          [separateDialCode]="true"
          [phoneValidation]="true"
          name="phoneNumber"
          formControlName="phoneNumber"
          matInput
        >
        </ngx-intl-tel-input>
        @if (phoneSubmitted() && !phoneForm.controls.phoneNumber.value) {
          <mat-error class="phone-error">Telefoonnummer is verplicht.</mat-error>
        }
        @if (phoneForm.controls.phoneNumber.hasError('validatePhoneNumber') && phoneForm.controls.phoneNumber.touched) {
          <mat-error class="phone-error">Telefoonnummer is incorrect.</mat-error>
        }
        @if (phoneForm.controls.phoneNumber.hasError('user-not-found')) {
          <mat-error class="phone-error">Er is iets misgegaan. Neem contact op met de helpdesk.</mat-error>
        }
        @if (
          !(
            (phoneForm.controls.phoneNumber.hasError('validatePhoneNumber') &&
              phoneForm.controls.phoneNumber.touched) ||
            phoneForm.controls.phoneNumber.hasError('user-not-found') ||
            (phoneSubmitted() && !phoneForm.controls.phoneNumber.value)
          )
        ) {
          <mat-error class="phone-error-placeholder">.</mat-error>
        }
      </div>
      <div class="action-button-wrapper">
        <button type="button" mat-stroked-button routerLink="/auth"><mat-icon>arrow_back</mat-icon> Terug</button>
        <button
          type="button"
          mat-flat-button
          (click)="signIn('phone')"
          [disabled]="awaitingResponse()"
          [class.spinner]="awaitingResponse()"
        >
          Volgende
        </button>
      </div>
    </form>
  }

  <!-- verification form -->
  @if (signInType() == 'phone' && signInStatus() == 'verification') {
    <form [formGroup]="verificationForm" class="verify-form">
      <mat-form-field hideRequiredMarker="true">
        <mat-label>Verificatie code</mat-label>
        <input matInput autocomplete="off" type="text" formControlName="code" />
        @if (verificationForm.controls.code.hasError('required')) {
          <mat-error>Je moet een verificatie code invullen.</mat-error>
        }
        @if (verificationForm.controls.code.hasError('no-confirmation-result')) {
          <mat-error>Er is iets misgegaan. Neem contact op met de helpdesk.</mat-error>
        }
        @if (verificationForm.controls.code.hasError('invalid-code')) {
          <mat-error>De code is ongeldig.</mat-error>
        }
      </mat-form-field>
      <div class="verification-button-wrapper">
        <button mat-stroked-button (click)="goBackFromVerification()"><mat-icon>arrow_back</mat-icon> terug</button>
        <button
          mat-flat-button
          (click)="verifyLoginCode()"
          [disabled]="awaitingResponse()"
          [class.spinner]="awaitingResponse()"
        >
          Verifiëren
        </button>
      </div>
    </form>
  }
</div>

@if (signInStatus() !== 'verification') {
  <div class="alternative-logins">
    <div class="alternative-sub-title">Of login met</div>
    <div class="alternate-login-button-wrapper">
      @if (signInType() !== 'email') {
        <button type="button" mat-stroked-button class="alternate-login-button" (click)="signInType.set('email')">
          <mat-icon>mail</mat-icon>E-mailadres
        </button>
      }
      @if (signInType() !== 'phone') {
        <button type="button" mat-stroked-button class="alternate-login-button" (click)="signInType.set('phone')">
          <mat-icon>call</mat-icon>Telefoonnummer
        </button>
      }
      <button mat-stroked-button class="alternate-login-button" (click)="googleLogin()">
        <div class="alternate-login-button-text-wrapper google-login">
          <img src="../../../../assets/images/google.png" alt="Google logo" />
          Google
        </div>
      </button>
    </div>
  </div>
}

@if (captcha()) {
  <div id="recaptcha-container"></div>
}
